"use strict";

var _typeof = require("/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visit = exports.EvaluationVisitor = exports.FormatVisitor = exports.ReferenceVisitor = exports.Transformer = exports.Visitor = void 0;

var _nodes = require("./nodes");

var _utils = require("./utils");

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var Visitor = /*#__PURE__*/function () {
  function Visitor() {
    _classCallCheck(this, Visitor);
  }

  _createClass(Visitor, [{
    key: "visit",
    value: // TODO: not safe
    // TODO: need to type this
    function visit(node) {
      var type = node.constructor;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      while (type !== _nodes.Node) {
        if (this["visit_".concat(type.type)]) {
          return this["visit_".concat(type.type)](node, args);
        }

        type = Object.getPrototypeOf(type);
      }

      return this.visit_Node(node, args);
    } // TODO: need to type this
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "recurseChildren",
    value: function recurseChildren(node, cb) {
      var ctr = node.constructor;
      var results = [];
      ctr.attrs.forEach(function (name) {
        var field = node[name];

        if (field instanceof _nodes.Node) {
          results.push(cb(field));
        } else if (field instanceof Array) {
          var results1 = [];
          field.forEach(function (sub) {
            if (sub instanceof _nodes.Node) {
              results1.push(cb(sub));
            }
          });
          results.push(results1);
        } else {
          results.push(field);
        }
      });
      return results;
    } // TODO: need to type this
    // eslint-disable-next-line camelcase

  }, {
    key: "visit_Node",
    value: function visit_Node(node) {
      var _this = this;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      this.recurseChildren(node, function (child) {
        return _this.visit(child, args);
      });
    }
  }]);

  return Visitor;
}();

exports.Visitor = Visitor;

var visit = function visit(node, cb) {
  var TempVisitor = /*#__PURE__*/function (_Visitor) {
    _inherits(TempVisitor, _Visitor);

    var _super = _createSuper(TempVisitor);

    function TempVisitor() {
      _classCallCheck(this, TempVisitor);

      return _super.apply(this, arguments);
    }

    _createClass(TempVisitor, [{
      key: "visit_Node",
      value: // eslint-disable-next-line class-methods-use-this, camelcase
      function visit_Node(n) {
        cb(n);

        _get(_getPrototypeOf(TempVisitor.prototype), "visit_Node", this).call(this, n);
      }
    }]);

    return TempVisitor;
  }(Visitor);

  return new TempVisitor().visit(node);
};

exports.visit = visit;

var Transformer = /*#__PURE__*/function (_Visitor2) {
  _inherits(Transformer, _Visitor2);

  var _super2 = _createSuper(Transformer);

  function Transformer() {
    _classCallCheck(this, Transformer);

    return _super2.apply(this, arguments);
  }

  _createClass(Transformer, [{
    key: "buildNode",
    value: // eslint-disable-next-line class-methods-use-this
    function buildNode(Type, attrs) {
      return _construct(Type, _toConsumableArray(attrs));
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_Node",
    value: function visit_Node(node) {
      var _this2 = this;

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      var changed = false;
      var async = false;
      var params = this.recurseChildren(node, function (child) {
        var rep = _this2.visit.apply(_this2, [child].concat(args));

        if (rep !== child) {
          changed = true;
        }

        if (rep instanceof Promise) {
          async = true;
        }

        return rep;
      });

      if (!changed) {
        return node;
      }

      if (async) {
        params = params.map(function (param) {
          if (param instanceof Array) {
            return Promise.all(param);
          }

          return param;
        });
        return Promise.all(params).then(function (x) {
          return _this2.buildNode(node.constructor, x);
        });
      }

      return this.buildNode(node.constructor, params);
    }
  }, {
    key: "transform",
    value: function transform(node) {
      return this.visit(node);
    }
  }]);

  return Transformer;
}(Visitor);

exports.Transformer = Transformer;

var ReferenceVisitor = /*#__PURE__*/function (_Visitor3) {
  _inherits(ReferenceVisitor, _Visitor3);

  var _super3 = _createSuper(ReferenceVisitor);

  function ReferenceVisitor() {
    _classCallCheck(this, ReferenceVisitor);

    return _super3.apply(this, arguments);
  }

  _createClass(ReferenceVisitor, [{
    key: "visit_Identifier",
    value: // eslint-disable-next-line class-methods-use-this, camelcase
    function visit_Identifier(node) {
      return [node.id];
    } // eslint-disable-next-line class-methods-use-this, camelcase

  }, {
    key: "visit_Node",
    value: function visit_Node(node) {
      var _this3 = this;

      var result = [];
      this.recurseChildren(node, function (child) {
        _this3.visit(child).forEach(function (ref) {
          if (!result.includes(ref)) {
            result.push(ref);
          }
        });
      });
      return result;
    }
  }]);

  return ReferenceVisitor;
}(Visitor);

exports.ReferenceVisitor = ReferenceVisitor;

var FormatVisitor = /*#__PURE__*/function (_Visitor4) {
  _inherits(FormatVisitor, _Visitor4);

  var _super4 = _createSuper(FormatVisitor);

  function FormatVisitor() {
    var _this4;

    _classCallCheck(this, FormatVisitor);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));
    _this4.escape = false;
    return _this4;
  }

  _createClass(FormatVisitor, [{
    key: "maybeEscape",
    value: function maybeEscape(str) {
      if (this.escape) {
        return (0, _utils.escapeHtml)(str);
      }

      return str;
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "formatOp",
    value: function formatOp(op) {
      return op.toString();
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_BinOp",
    value: function visit_BinOp(node) {
      var left = (0, _utils.maybeParen)(node, node.left, false, this.visit(node.left));
      var right = (0, _utils.maybeParen)(node, node.right, true, this.visit(node.right));
      return "".concat(left, " ").concat(this.formatOp(node.op), " ").concat(right);
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_UnaryOp",
    value: function visit_UnaryOp(node) {
      var operand = (0, _utils.maybeParen)(node, node.operand, false, this.visit(node.operand));
      return "".concat(this.formatOp(node.op), " ").concat(operand);
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_BoolOp",
    value: function visit_BoolOp(node) {
      var _this5 = this;

      var ops = node.operands.map(function (op) {
        return (0, _utils.maybeParen)(node, op, false, _this5.visit(op));
      });
      return ops.join(" ".concat(this.formatOp(node.op), " "));
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_Attribute",
    value: function visit_Attribute(node) {
      return "".concat(this.visit(node.value), ".").concat(this.maybeEscape(node.attr));
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_Call",
    value: function visit_Call(node) {
      var _this6 = this;

      var args = node.args.map(function (arg) {
        return _this6.visit(arg);
      });
      return "".concat(this.visit(node.func), "(").concat(args.join(', '), ")");
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_List",
    value: function visit_List(node) {
      var _this7 = this;

      return "[".concat(node.items.map(function (item) {
        return _this7.visit(item);
      }).join(', '), "]");
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_Node",
    value: function visit_Node(node) {
      return this.maybeEscape(node.toString());
    }
  }]);

  return FormatVisitor;
}(Visitor);

exports.FormatVisitor = FormatVisitor;

var EvaluationVisitor = /*#__PURE__*/function (_Visitor5) {
  _inherits(EvaluationVisitor, _Visitor5);

  var _super5 = _createSuper(EvaluationVisitor);

  function EvaluationVisitor(context) {
    var _this8;

    _classCallCheck(this, EvaluationVisitor);

    _this8 = _super5.call(this);
    _this8.context = context;
    return _this8;
  } // eslint-disable-next-line class-methods-use-this


  _createClass(EvaluationVisitor, [{
    key: "toNumber",
    value: function toNumber(arg) {
      return Number(arg);
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "isEmpty",
    value: function isEmpty(arg) {
      if (arg === null || arg === undefined) {
        return true;
      }

      if (typeof arg === 'string' && arg.trim() === '') {
        return true;
      }

      if (Array.isArray(arg) && arg.length === 0) {
        return true;
      }

      return false;
    }
  }, {
    key: "isTruthy",
    value: function isTruthy(arg) {
      return !this.isEmpty(arg) && arg;
    }
  }, {
    key: "arithOp",
    value: function arithOp(left, right, func) {
      if (left === null || right === null) {
        return null;
      }

      var result = func(this.toNumber(left), this.toNumber(right));

      if (!Number.isFinite(result) || Number.isNaN(result)) {
        return null;
      }

      return result;
    }
  }, {
    key: "cmpOp",
    value: function cmpOp(name, // TODO: name can be made more safe with a string literal or enum
    left, right, func) {
      var _left$, _right$;

      if (left === null || right === null) {
        return null;
      }

      var result = (_left$ = left["__".concat(name, "__")]) === null || _left$ === void 0 ? void 0 : _left$.call(left, right);

      if (result !== undefined) {
        return result;
      }

      result = (_right$ = right["__".concat(name, "__")]) === null || _right$ === void 0 ? void 0 : _right$.call(right, left);

      if (result !== undefined) {
        return result;
      }

      if (typeof left === 'boolean' || typeof right === 'boolean') {
        return func(this.toNumber(left) - this.toNumber(right));
      }

      if (typeof left === 'number' || typeof right === 'number') {
        return func(this.toNumber(left) - this.toNumber(right));
      }

      return func(left.toString().localeCompare(right.toString(), 'en', {
        sensitivity: 'accent'
      }));
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_UnaryOp",
    value: function visit_UnaryOp(node) {
      var op = this.visit(node.operand);

      if (node.op === _nodes.Op.Not && op !== null) {
        return !this.isTruthy(op);
      }

      return null;
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_BoolOp",
    value: function visit_BoolOp(node) {
      var result;

      if (node.op === _nodes.Op.And) {
        result = true;

        for (var i = 0; i < node.operands.length; i += 1) {
          var op = node.operands[i];
          var arg = this.visit(op);

          if (arg !== null && !arg) {
            return arg;
          }

          if (result !== null) {
            result = arg;
          }
        }
      }

      if (node.op === _nodes.Op.Or) {
        result = false;

        for (var _i = 0; _i < node.operands.length; _i += 1) {
          var _op = node.operands[_i];

          var _arg = this.visit(_op);

          if (_arg) {
            return _arg;
          }

          if (result !== null && result !== undefined) {
            result = _arg;
          }
        }
      }

      return result;
    } // TODO: make sure all cases are being handled
    // eslint-disable-next-line camelcase, consistent-return

  }, {
    key: "visit_BinOp",
    value: function visit_BinOp(node) {
      var _ref = [this.visit(node.left), this.visit(node.right)],
          left = _ref[0],
          right = _ref[1];

      switch (node.op) {
        case _nodes.Op.Add:
          return this.arithOp(left, right, function (l, r) {
            return l + r;
          });

        case _nodes.Op.Sub:
          return this.arithOp(left, right, function (l, r) {
            return l - r;
          });

        case _nodes.Op.Mul:
          return this.arithOp(left, right, function (l, r) {
            return l * r;
          });

        case _nodes.Op.Div:
          return this.arithOp(left, right, function (l, r) {
            return l / r;
          });

        case _nodes.Op.Eq:
          return this.cmpOp('eq', left, right, function (cmp) {
            return cmp === 0;
          });

        case _nodes.Op.Ne:
          return this.cmpOp('ne', left, right, function (cmp) {
            return cmp !== 0;
          });

        case _nodes.Op.Gt:
          return this.cmpOp('gt', left, right, function (cmp) {
            return cmp > 0;
          });

        case _nodes.Op.Lt:
          return this.cmpOp('lt', left, right, function (cmp) {
            return cmp < 0;
          });

        case _nodes.Op.Ge:
          return this.cmpOp('ge', left, right, function (cmp) {
            return cmp >= 0;
          });

        case _nodes.Op.Le:
          return this.cmpOp('le', left, right, function (cmp) {
            return cmp <= 0;
          });

        case _nodes.Op.In:
        case _nodes.Op.NotIn:
          {
            var _left$__in__;

            var invert = node.op === _nodes.Op.NotIn;
            var result = left === null || left === void 0 ? void 0 : (_left$__in__ = left.__in__) === null || _left$__in__ === void 0 ? void 0 : _left$__in__.call(left, right);

            if (result !== undefined) {
              return result !== invert;
            }

            if (Array.isArray(right)) {
              for (var i = 0; i < right.length; i += 1) {
                var item = right[i];

                if (this.cmpOp('eq', left, item, function (cmp) {
                  return cmp === 0;
                })) {
                  return invert !== true;
                }
              }

              return invert !== false;
            }

            return null;
          }

        case _nodes.Op.Ct:
        case _nodes.Op.NotCt:
          {
            var _left$__ct__;

            var _invert = node.op === _nodes.Op.NotCt;

            var _result = left === null || left === void 0 ? void 0 : (_left$__ct__ = left.__ct__) === null || _left$__ct__ === void 0 ? void 0 : _left$__ct__.call(left, right);

            if (_result !== undefined) {
              return _result !== _invert;
            }

            if (typeof left === 'string' && typeof right === 'string') {
              var lowerLeft = left.toLowerCase();
              var lowerRight = right.toLowerCase();

              if (/^\^/.test(right)) {
                var trimmedRight = lowerRight.substring(1);
                return lowerLeft.lastIndexOf(trimmedRight, 0) === 0 !== _invert;
              }

              if (/\$$/.test(right)) {
                var _trimmedRight = lowerRight.substring(0, lowerRight.length - 1);

                return lowerLeft.indexOf(_trimmedRight, lowerLeft.length - _trimmedRight.length) !== -1 !== _invert;
              }

              return lowerLeft.indexOf(lowerRight) >= 0 !== _invert;
            }

            return null;
          }

        case _nodes.Op.Is:
        case _nodes.Op.IsNot:
          {
            var _invert2 = node.op === _nodes.Op.IsNot;

            if (node.right instanceof _nodes.Null) {
              return left === null !== _invert2;
            }

            if (node.right instanceof _nodes.Empty) {
              return this.isEmpty(left) !== _invert2;
            }

            return left === right !== _invert2;
          }

        default:
          {
            // TODO: turn node.op into a finite type?
            throw new Error("Operator not supported: ".concat(node.op));
          }
      }
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_Attribute",
    value: function visit_Attribute(node) {
      var value = this.visit(node.value);

      if (value === null) {
        return null;
      } // eslint-disable-next-line no-prototype-builtins


      if (value.hasOwnProperty(node.attr)) {
        return value[node.attr];
      }

      return null;
    } // TODO: what if the context does not have the id?
    // eslint-disable-next-line camelcase, consistent-return

  }, {
    key: "visit_Identifier",
    value: function visit_Identifier(node) {
      if (node.id in this.context) {
        return this.context[node.id];
      }
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_Call",
    value: function visit_Call(node) {
      var _this9 = this;

      var func = this.visit(node.func);

      if (typeof func !== 'function') {
        return null;
      }

      if (func.lazy) {
        return func.apply(void 0, [function (arg) {
          return _this9.visit(arg);
        }].concat(_toConsumableArray(node.args)));
      }

      return func.apply(void 0, _toConsumableArray(node.args.map(function (arg) {
        return _this9.visit(arg);
      })));
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_List",
    value: function visit_List(node) {
      var _this10 = this;

      return node.items.map(function (item) {
        return _this10.visit(item);
      });
    } // eslint-disable-next-line camelcase, class-methods-use-this

  }, {
    key: "visit_Null",
    value: function visit_Null(node) {
      return null;
    } // eslint-disable-next-line camelcase, class-methods-use-this

  }, {
    key: "visit_Empty",
    value: function visit_Empty(node) {
      return null;
    } // eslint-disable-next-line class-methods-use-this, camelcase

  }, {
    key: "visit_Constant",
    value: function visit_Constant(node) {
      return node.valueOf();
    } // eslint-disable-next-line camelcase

  }, {
    key: "visit_Node",
    value: function visit_Node(node) {
      var _node$__eval__;

      var result = (_node$__eval__ = node.__eval__) === null || _node$__eval__ === void 0 ? void 0 : _node$__eval__.call(node, this.context);

      if (result !== undefined) {
        return result;
      }

      return null;
    }
  }]);

  return EvaluationVisitor;
}(Visitor);

exports.EvaluationVisitor = EvaluationVisitor;